import './ek-scroll-cursor.scss'

// inject the cursor as the first element on the page
const cursor = document.createElement('div');
cursor.className = 'ek-scroll-cursor';
cursor.setAttribute('aria-hidden', 'true');
document.body.prepend(cursor);

//<div class="ek-scroll-cursor" aria-hidden="true"></div>

const cs = getComputedStyle(cursor);
const START = parseInt(cs.getPropertyValue('--ek-cursor-start')) || 140;

const darks  = [...document.querySelectorAll('.ek-hero, .ek-foryou, .ek-trust-lp')];
const footer = document.querySelector('.footer-shared');

function update() {
  const maxScroll = document.body.scrollHeight - innerHeight;
  const p = maxScroll > 0 ? scrollY / maxScroll : 0;
  const y = START + p * (innerHeight - 38);
  cursor.style.top = y + 'px';

  const mid = y + 19;

  // hide over the footer (only if a footer exists)
  if (footer) {
    const fr = footer.getBoundingClientRect();
    if (fr.top <= mid + 38) {
      cursor.style.display = 'none';
      return;
    }
    cursor.style.display = 'block';
  }

  const onDark = darks.some(s => {
    const r = s.getBoundingClientRect();
    return r.top <= mid && r.bottom >= mid;
  });
  cursor.classList.toggle('on-dark', onDark);
}

addEventListener('scroll', update, { passive: true });
addEventListener('resize', update);
update();